import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CertificadosFsItemResultsViewModel, CertificadosFsItemViewModel, FilterSearchingCertificadosFsViewModel } from './buscador-certificadosfs.types';
import { SolicitudEnvioExViewModel } from '../../solicitudes/envio/envioEx.types';

@Injectable()
export class CertificadosFsService {
    public currentFilter = new FilterSearchingCertificadosFsViewModel();
    private lastSearch?: FilterSearchingCertificadosFsViewModel;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    private convertModelToHttpParms(payload: FilterSearchingCertificadosFsViewModel): HttpParams {
        let params = new HttpParams();
        let k: keyof FilterSearchingCertificadosFsViewModel;

        for (k in payload) {
            let v: string | number | boolean | Date;
            let valor = payload[k];
            if (valor instanceof Date) {
                v = (valor as Date).toLocaleDateString();
            } else {
                v = valor || '';
            }
            params = params.append(k, v);
        }

        return params;
    }

    postSolicitudPagedByFilter(payload: FilterSearchingCertificadosFsViewModel): Observable<CertificadosFsItemResultsViewModel> {
        this.lastSearch = { ...payload }; // Keep for future search
        const params = this.convertModelToHttpParms(this.lastSearch);
        return this.pagedByFilter(params);
    }

    pagedByFilter(params: HttpParams): Observable<any> {
        return this.http.get<FilterSearchingCertificadosFsViewModel>(this.baseUrl + 'api/exportacion/CertificadosFs/PagedByfilter', { params: params }).pipe();
    }

    export(model: FilterSearchingCertificadosFsViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/exportacion/CertificadosFs/postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    getSolicitud(id: number): Observable<SolicitudEnvioExViewModel> {
        return this.http.get<SolicitudEnvioExViewModel>(this.baseUrl + 'api/exportacion/CertificadosFs/getsolicitudbyid/' + id).pipe();
    }

    getCertificado(id: number): Observable<CertificadosFsItemViewModel> {
        return this.http.get<CertificadosFsItemViewModel>(this.baseUrl + 'api/exportacion/CertificadosFs/getcertificadobyid/' + id).pipe();
    }

    editSolicitud(documento: SolicitudEnvioExViewModel): Observable<any> {
        return this.http.put<SolicitudEnvioExViewModel>(this.baseUrl + 'api/exportacion/CertificadosFs', documento).pipe();
    }

    resetFilterSolicitud() {
        this.currentFilter = new FilterSearchingCertificadosFsViewModel();
    }

    getLastSearch(): FilterSearchingCertificadosFsViewModel | undefined {
        return this.lastSearch;
    }

    clearLastSearch(): void {
        this.lastSearch = undefined;
    }
}
